import { useTranslation } from 'react-i18next';
import './ErrorPage.css';

// The page shown when something is wrong: a page that crashed
// (ErrorBoundary.js) or an address that doesn't exist (pages/NotFound.js).
// A big italic line, a sentence, and a way out - on paper, in the site's ink.
//
// `reload` adds a "reload" button, for a crash; a page that is simply not
// there only needs the way home.
function ErrorPage({ title, body, reload = false }) {
  const { t } = useTranslation();

  return (
    <div className="crash" role={reload ? 'alert' : undefined}>
      <h1>{title}</h1>
      <p>{body}</p>
      <p className="crash-actions">
        {reload && (
          <button type="button" onClick={() => window.location.reload()}>
            {t('crash.reload')}
          </button>
        )}
        <a href="/">{t('crash.home')}</a>
      </p>
    </div>
  );
}

export default ErrorPage;
